import AccessTimeOutlined from "@mui/icons-material/AccessTimeOutlined";
import MoveToInboxOutlined from "@mui/icons-material/MoveToInboxOutlined";
import PersonOutlineRounded from "@mui/icons-material/PersonOutlineRounded";
import DnsOutlined from "@mui/icons-material/DnsOutlined";
import SwapHorizOutlined from "@mui/icons-material/SwapHorizOutlined";
import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import ToggleOnOutlined from "@mui/icons-material/ToggleOnOutlined";

// Serializable names keep server filter configuration and saved preferences
// independent of React elements.
export const filterFieldIcons = {
  time: AccessTimeOutlined,
  received: MoveToInboxOutlined,
  employee: PersonOutlineRounded,
  device: DnsOutlined,
  direction: SwapHorizOutlined,
  stage: AccountTreeOutlined,
  status: ToggleOnOutlined,
};
